export const typeOfDocuments = {
	checkbox: 7,
	date: 3,
	text: 4,
    select: 5,
    signature: 6,
    radio: 8,
    number: 9,
    initials: 10,
};

export const typeOfDocumentsLabels = {
	checkbox: "checkbox",
	date: "date",
	text: "text",
	shortText: "shortText",
	select: "select",
	signature: "signature",
	radio: "radio",
	number: "number",
	file: "file",
	initial: "initial",
	initials: "initials",
};
